import { useState } from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Command, CommandInput, CommandList, CommandEmpty, CommandItem } from '@/components/ui/command';

export interface PickerTeam { registration_id: string; team_name: string; coach_email?: string; division?: string }

export function HotelTeamPicker({ teams, value, onChange, disabled = false }: {
  teams: PickerTeam[]; value?: string; onChange: (id: string) => void; disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  return <Popover open={open} onOpenChange={setOpen}>
    <PopoverTrigger asChild><Button variant="outline" role="combobox" aria-expanded={open} disabled={disabled}
      className="min-h-11 w-full min-w-44 justify-between gap-2 text-left">
      <span className="truncate">{teams.find(t => t.registration_id === value)?.team_name || 'Link to team'}</span>
      <ChevronsUpDown className="h-4 w-4 shrink-0" />
    </Button></PopoverTrigger>
    <PopoverContent align="start" className="w-80 max-w-[calc(100vw-2rem)] p-0">
      <Command><CommandInput placeholder="Search team or coach email…" />
        <CommandList className="max-h-64"><CommandEmpty>No matching teams.</CommandEmpty>
          {[...teams].sort((a,b) => a.team_name.localeCompare(b.team_name)).map(team =>
            <CommandItem key={team.registration_id} value={`${team.team_name} ${team.coach_email || ''} ${team.registration_id}`}
              className="min-h-11 gap-2" onSelect={() => { onChange(team.registration_id); setOpen(false); }}>
              <div className="min-w-0 flex-1"><div className="break-words">{team.team_name}</div>
                <div className="text-xs text-muted-foreground break-all">{team.division} {team.coach_email}</div></div>
              {value === team.registration_id && <Check className="h-4 w-4" />}
            </CommandItem>)}
        </CommandList>
      </Command>
    </PopoverContent>
  </Popover>;
}